import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "view-comments-container" }
const _hoisted_2 = { class: "views" }
const _hoisted_3 = { class: "share" }

import commentsIcon from '@/assets/svg/commentsIcon.vue';
  import statsIcon from '@/assets/svg/statsIcon.vue';
  import shareIcon from '@/assets/svg/shareIcon.vue';
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'viewCommentsAtom',
  props: {
    resource_id: String,
  },
  emits: ['open'],
  setup(__props, { emit: __emit }) {

  const emit = __emit;

  const props = __props;
  const store = useStore();
  const comments = computed(() => store.getters['comment/getCount']);
  const viewCount = computed(
    () => store.getters['resource/getResource']?.view_count ?? 0,
  );

  const handleClick = () => {
    emit('open');
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(statsIcon),
      _createElementVNode("h4", null, "Number of views (" + _toDisplayString(viewCount.value) + ")", 1)
    ]),
    _createElementVNode("div", {
      class: "comments comments-icon",
      onClick: handleClick
    }, [
      _createVNode(commentsIcon),
      _createElementVNode("h4", null, "View post comments (" + _toDisplayString(comments.value?.toString() ?? 0) + ")", 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(shareIcon, {
        color: "grey",
        class: "comments-icon"
      })
    ])
  ]))
}
}

})